import {
  createStyles,
  Theme,
  withStyles,
  WithStyles
} from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { IAddMealStore } from './AddMealStore';

import { IDiaryPageStore } from '../../DiaryPageStore';

import {
  Button,
  CardActions,
  // Divider,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';

import {
  Camera
} from '@material-ui/icons';

import { ICameraStore } from '../../../components/camera/CameraStore';
import ImageButton from '../../../components/imageButton/ImageButton';
import { IRouteStore } from '../../../RouteStore';


const styles = (theme: Theme) => createStyles({
  actions: {
    alignContent: 'center',
    display: 'flex',
  },
  button: {
    margin: 'auto'
  }
});

declare type stylesKeys = 'actions' | 'button';

interface IAddMealViewProps extends InjectedIntlProps {
  addMeal: IAddMealStore;
  camera: ICameraStore;
  diaryPage: IDiaryPageStore;
  routes: IRouteStore;
}

@observer
class AddMealView extends React.Component<IAddMealViewProps & WithStyles<stylesKeys>, {}> {

  public render() {
    const { addMeal, camera, classes, intl: { formatMessage } } = this.props;

    addMeal.setPhoto(camera.image);

    return <React.Fragment>
        <Typography variant="h6" gutterBottom={true}>
          {formatMessage({id: 'diary.meal.add.title'})}
        </Typography>
        <Grid container={true} spacing={24}>
          <Grid item={true} xs={6} sm={6}>
            <TextField
              id="date"
              label={formatMessage({id: 'diary.meal.add.form.date'})}
              type="date"
              value={addMeal.date}
              fullWidth={true}
              onChange={this.onDateChange}
            />
          </Grid>
          <Grid item={true} xs={6} sm={6}>
            <TextField
              id="time"
              label={formatMessage({id: 'diary.meal.add.form.time'})}
              type="time"
              value={addMeal.time}
              fullWidth={true}
              onChange={this.onTimeChange}
            />
          </Grid>
          <Grid item={true} xs={12} sm={12}>
            <ImageButton
              url={addMeal.photo
                ? window.URL.createObjectURL(addMeal.photo)
                : undefined
              }
              icon={<Camera style={{height: '50px', width: '50px',}}/>}
              onClick={this.takePhoto}
            />
          </Grid>
          <Grid item={true} xs={12} sm={12}>
            <TextField
              required={true}
              id="description"
              name="description"
              label={formatMessage({id: 'diary.meal.add.form.description'})}
              fullWidth={true}
              multiline={true}
              value={addMeal.description}
              onChange={this.onDescriptionChange}
              rows={5}
              rowsMax={10}
            />
          </Grid>
        </Grid>
        <CardActions className={classes.actions} disableActionSpacing={true}>
          <Button aria-label="Photo" variant="contained" className={classes.button} onClick={this.cancel}>
            Cancel
          </Button>
          <Button aria-label="Photo" variant="contained" color="secondary" disabled={!addMeal.valid} className={classes.button} onClick={this.submit}>
            Add
          </Button>
        </CardActions>
      </React.Fragment>;
  }

  private takePhoto = () => {
    const { routes } = this.props;
    routes.navigate('camera');
  }

  private onDateChange = (event: any) => {
    const { addMeal } = this.props;
    if (event && event.target && event.target.value) {
      addMeal.setDate(event.target.value);
    }
  }

  private onTimeChange = (event: any) => {
    const { addMeal } = this.props;
    if (event && event.target && event.target.value) {
      addMeal.setTime(event.target.value);
    }
  }

  private onDescriptionChange = (event: any) => {
    const { addMeal } = this.props;
    if (event && event.target) {
      addMeal.setDescription(event.target.value);
    }
  }

  private submit = () => {
    const { addMeal, diaryPage, routes } = this.props;
    addMeal.submit()
      .then(() => {
        diaryPage.setDate(addMeal.getDate());
        routes.navigate('diary');
      });
  }

  private cancel = () => {
    const { routes } = this.props;
    routes.navigate('diary');
  }

}

export default withStyles<stylesKeys>(styles)(injectIntl<WithStyles<stylesKeys> & InjectedIntlProps>(inject('addMeal', 'camera', 'diaryPage', 'routes')(AddMealView)));



// WEBPACK FOOTER //
// ./src/diary/meal/add/AddMealView.tsx